import { NamedError } from '../../utils/Errors';

export class AugloopError extends NamedError<AugloopErrors> {}

export enum AugloopErrors {
    SessionInitTimeout = 'SessionInitTimeout'
}